import InternalLink from '../../../components/InternalLink';
import Markup from '../../../components/Markup';
import SlantedButton from '../../../components/SlantedButton';
import TextSwish from '../../../components/TextSwish';
import Typography from '../../../components/Typography';
import { asyncRequestStates } from '../../../hooks/useAsyncRequest';
import routes from '../../../services/constants/routes';
import useStatsPageContent from '../../stats/hooks/useStatsPageContent';
import useStyles from './homeStats.styles';
import StatsWheels from './StatsWheels';

const HomeStats = () => {
  const styles = useStyles();
  const {
    pageContent: { header },
    pageContentState,
  } = useStatsPageContent();

  if (!routes.stats) return null;

  return (
    pageContentState === asyncRequestStates.SUCCESS && (
      <div className={styles.wrapper}>
        <div className={styles.backgroundCircle} />
        <div className={styles.header}>
          <Typography variant="title" withShadow>
            {header.title}
            <TextSwish isCentered />
          </Typography>
        </div>
        <StatsWheels />
        <Typography
          className={styles.calculated}
          component="div"
          variant="body"
        >
          <Markup content={header.body} />
        </Typography>
        <div className={styles.buttonWrapper}>
          <SlantedButton
            className={styles.button}
            component={InternalLink}
            to={routes.stats.path}
          >
            See all {header.title}
          </SlantedButton>
        </div>
      </div>
    )
  );
};

export default HomeStats;
